// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"2348aab5","368":"3b19ad7b","641":"072c2f3f"}[chunkId] + ".css";
};